import React from 'react';
import './Header.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Header(props) {

  //check whether to render webp or png
  let imageType = "png"
  if (props.webP === "webp") {
    imageType = "webp"
  }
  
  return (
    <nav className={'Header ' + props.windowSize}>
      <a href="https://www.basler.com"><img alt="Basler Logo" src={process.env.PUBLIC_URL + '/Assets/Images/BElogoVERTICAL_white.' + imageType}></img></a>
      <p id="social-media">
        <a href="https://www.facebook.com/baslerelectric"><FontAwesomeIcon icon={['fab', 'facebook-square']}/></a>
        <a href="https://www.linkedin.com/company/basler-electric-company"><FontAwesomeIcon icon={['fab', 'linkedin']}/></a>
        <a href="https://www.youtube.com/playlist?list=PLlRokf4uBcT-wqX1Wso2bgnQhXV4ZhMqs"><FontAwesomeIcon icon={['fab', 'youtube-square']}/></a>
      </p>
    </nav>
  );
}

export default Header;